import localService from "../services/localService";

/**
 * Extracts the redirect URL from the payload and deletes the key from the payload object.
 * Returns the redirect URL, or "/" as the default.
 */
export function extractRedirectUrl(payload) {
  let defaultRedirectUrl = "/";
  if (payload.redirect) {
    defaultRedirectUrl = payload.redirect;
    delete payload.redirect;
  }
  return defaultRedirectUrl;
}

/**
 * Returns true if the user is a client with an expired subscription.
 */
export function isSubscriptionExpired(data) {
  return data.user?.role == "client" && data.user?.subscription_expired;
}

/**
 * If the user has client delegations, marks the onboarding delegation steps as completed.
 */
export function applyDelegationFlags(user) {
  if (user.client_delegations && Object.keys(user.client_delegations)?.length) {
    user.onboard_delegate_completed = true;
    user.onboard_invite_members_completed = true;
  }
}

/**
 * Commits the user session to the Vuex store and persists to local storage.
 */
export function commitUserSession(commit, currentUser, data) {
  commit("setState", { key: "currentUser", value: currentUser });
  localService.setItem("userInfo", data);
  commit("setState", { key: "isLoggedIn", value: true });
}
